<div class="wrapper" data-testid="delete-account-container">
  <!-- Header -->
  <div class="header">
    <img class="evnavi-logo" src="assets/icons/light/logo/ev_navigation_logo.png" alt="EVNavigation Logo" />
  </div>

  <!-- Body -->
  <div id="reset-body">
    @if (languageJSON(); as lang) {

      <!-- SUCCESS -->
      @if (viewState() === 'success') {
        <div id="bodycontent-start">
          <p class="smaller" [innerHTML]="lang.DeleteAccount_SuccesText1"></p>
          <p class="smaller" [innerHTML]="lang.DeleteAccount_SuccesText2"></p>
        </div>
      }

      <!-- ERROR -->
      @if (viewState() === 'error') {
        <div id="bodycontent-start">
          <p class="smaller" [innerHTML]="lang.DeleteAccount_ErrorText1"></p>
          <p class="smaller" [innerHTML]="lang.DeleteAccount_ErrorText2"></p>
        </div>
      }

      <!-- FORM -->
      @if (viewState() === 'form') {
        <ng-container class="form-container">
          <div id="bodycontent-start">
            <p class="smaller" [innerHTML]="lang.DeleteAccount_FormText1"></p>
            <p class="smaller" [innerHTML]="lang.DeleteAccount_FormText2"></p>
            @if (!loading()) {
              <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form-form" data-testid="delete-account-form" novalidate>
                <p class="form-info-text" [innerHTML]="lang.DeleteAccount_FormText3"></p>
                <input id="form-delete" name="form-delete" data-testid="delete-account-delete-input" formControlName="delete" type="text" required />
                <button type="submit" class="button text-size-corr" [class.disabled]="form.invalid || loading()"
                  [disabled]="form.invalid || loading()" id="form-submit-btn" data-testid="delete-account-submit-btn">
                  {{ lang.DeleteAccount_ButtonText }}
                </button>
              </form>
            }
            @if (loading()) {
              <mat-spinner id="loading-spinner" strokeWidth="6"></mat-spinner>
            }
          </div>
        </ng-container>
      }
    }
  </div>

  <!-- Footer -->
  <div class="footer">
    <img src="assets/icons/default/ui/floating_car_icon.png" alt="" class="floatingcar" />

    <a class="social_icons" data-testid="delete-account-app-store-link" href="https://apps.apple.com/app/ev-navigation/id1494131819">
      <img class="app-store-icon" src="assets/icons/default/social/en/app_store_button.svg"
        alt="Get in on Apple store" />
      </a>

      <a class="social_icons" data-testid="delete-account-google-play-link" href="https://play.google.com/store/apps/details?id=com.gpstuner.evnavigation">
        <img class="google-play-icon" src="assets/icons/default/social/en/google_play_button.svg"
          alt="Get it on Google Play" />
        </a>

        <div>
          <img src="/assets/icons/light/logo/navity_logo.svg" alt="GPS Tuner Systems logo" class="gpst-logo" />
        </div>

        Copyright © 2020-2026 GPS TUNER SYSTEMS KFT. - All rights reserved.
      </div>
    </div>